import { magicLinkClient, organizationClient, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/** Same-origin in dev (Vite proxy); VITE_API_URL points at api.<root> in deployed builds. */
export const API_BASE = import.meta.env.VITE_API_URL ?? "";

export const authClient = createAuthClient({
  baseURL: API_BASE,
  basePath: "/v1/auth",
  plugins: [organizationClient(), twoFactorClient(), magicLinkClient()],
});

export const GOOGLE_ENABLED = import.meta.env.VITE_GOOGLE_ENABLED === "true";
